registerComponent("pages/help", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 3`, `slidesToScroll: 3`, `1` no celular, com
 * `prevArrow`/`nextArrow`/`appendDots` apontando para o `blocks/slider-controls`
 * ao lado) vira um `Asa.trilho`. O degrau mora no LESS: fora do celular a lista
 * é grade e o trilho se desativa sozinho, porque lê `scroll-snap-type: none`.
 *
 * ⚠️ Este componente NÃO RENDERIZA em nenhuma URL — ele chama
 * `sections/home-insights` sem `data`, e aquele componente estoura em
 * `$data['contents']`. O estado real está travado em
 * `UnreferencedComponentsTest::test_pages_help_does_not_render`, e a página de
 * ajuda que está no ar é `/faq`, servida por `pages/faq`. Logo, nada aqui é
 * exercitado pelo `browser-check`: o que prova este arquivo é o `yarn lint`, o
 * `node --check` do bundle e o grep de dependência legada. Candidato ao
 * protocolo de remoção da Fase 9, junto de `pages/wealth-planning`.
 */

const lista = component.querySelector('.slider-help');

if (lista) {
    Asa.trilho(lista, Object.assign(
        { itens: '.card', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
    ));
}

});
